import {
  Box,
  LinearProgress,
  Tab,
  Tabs,
} from "@mui/material";
import {
  Person as PersonIcon,
  Business as BusinessIcon,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Profile from "./sections/profile";
import HubSection from "./sections/hub";
import NavBarLayout from "../../components/nav-bar-layout";

type TabItem = {
  label: string;
  value: string;
  icon: React.ReactNode;
};

const tabs: TabItem[] = [
  { label: "Profile", value: "profile", icon: <PersonIcon /> },
  { label: "Hub", value: "hub", icon: <BusinessIcon /> },
];

export default function Account() {
  const navigate = useNavigate();
  const location = useLocation();

  const [tabValue, setTabValue] = useState(location.hash.replace("#", "") || "profile");


  const [mountedTabs, setMountedTabs] = useState<string[]>([tabValue]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
    navigate(`#${newValue}`);
    if (!mountedTabs.includes(newValue)) {
      setMountedTabs((prev) => [...prev, newValue]);
    }
  };

  useEffect(() => {
    setTabValue(tabValue);
    if (!mountedTabs.includes(tabValue)) {
      setMountedTabs((prev) => [...prev, tabValue]);
    }
  }, [tabValue]);

  return (
    <NavBarLayout>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="standard"
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 3,
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box>
        {mountedTabs.includes("profile") && (
          <Box sx={{ display: tabValue === "profile" ? "block" : "none" }}>
            <Profile />
          </Box>
        )}
        {mountedTabs.includes("hub") && (
          <Box sx={{ display: tabValue === "hub" ? "block" : "none" }}>
            <HubSection />
          </Box>
        )}
      </Box>
    </NavBarLayout>
  );
}
